export default {
  'Resolution': '해상도',
  'Frame rate': '프레임률',
  'The higher the frame rate, the smoother the animation': '프레임률이 높을수록 애니메이션이 매끄러워집니다.',
}